import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";
import { OrderedProduct } from "@/model/OrderedProduct";

export class FabricationOrderedProductsBreakdown implements Serializable {
    productsToProcess: OrderedProduct[];
    productsProcessed: OrderedProduct[];
    
    fromJSON(rawObject: any): void {
        if (rawObject['productsToProcess'] != null) {
            this.productsToProcess = SerializationHelper.toArrayInstanceFromJsonObjArray(() => new OrderedProduct(), rawObject['productsToProcess']);
        }
        if (rawObject['productsProcessed'] != null) {
            this.productsProcessed = SerializationHelper.toArrayInstanceFromJsonObjArray(() => new OrderedProduct(), rawObject['productsProcessed']);
        }
    }
}
